/**
 * Browser translators and some extensions move or replace text nodes that React owns. React then
 * calls removeChild / insertBefore with a node that is no longer where it left it and the whole page
 * crashes ("Failed to execute 'insertBefore' on 'Node'"). index.html already asks browsers not to
 * translate; for tools that ignore it, these guards let React carry on instead of crashing
 * (https://github.com/facebook/react/issues/11538).
 */
export function installDomGuard(): void {
  // The originals are always called with the right `this` through .call().
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const removeChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) return child
    return removeChild.call(this, child) as T
  }
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const insertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) return insertBefore.call(this, node, null) as T
    return insertBefore.call(this, node, ref) as T
  }
}
